import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { AppButtonPricing } from '@/features/product-card/app-button';
import { Snackbar } from '@/features/snackbar';
import { generateVariantErrorMessage } from '../../_utils/generate-variant-error-message';
import { showVariantErrorToast } from '../../_utils/show-variant-error-toast';
import { useVariantContextValues } from '../../context/use-variant-context-values';
import PDPButton from '../pdp-button';
import SnappPayMessage from '../snapp-pay-message';
interface Props {
  hasPhoto: boolean;
}
const BuyBoxSale = ({
  hasPhoto
}: Props) => {
  const [showVariantError, setShowVariantError] = useState(false);
  const {
    activeVariant,
    activePricing,
    hasWeightOptions,
    hasColorOptions,
    hasAtleastOneWeightUnit
  } = useVariantContextValues('pdp');
  const {
    basePrice,
    discountPercent,
    effectivePrice
  } = activePricing;
  const variantErrorMessage = useMemo(() => generateVariantErrorMessage({
    hasWeightOptions,
    hasColorOptions,
    hasAtleastOneWeightUnit
  }), [hasWeightOptions, hasColorOptions, hasAtleastOneWeightUnit]);
  const showVariantErrorHandler = () => {
    if (hasPhoto) {
      showVariantErrorToast(variantErrorMessage);
      return;
    }
    setShowVariantError(true);
    setTimeout(() => setShowVariantError(false), 4000);
  };
  useEffect(() => {
    if (!activeVariant?.itemProposalId) return;
    setShowVariantError(false);
  }, [activeVariant?.itemProposalId]);
  return <div className={classNames('flex w-full flex-col items-center justify-center', hasPhoto ? 'gap-2' : 'gap-0')} data-sentry-component="BuyBoxSale" data-sentry-source-file="buy-box-sale.tsx">
            <AppButtonPricing basePrice={basePrice} discountPercent={discountPercent} effectivePrice={effectivePrice} withGoldPricing contextType='pdp' data-sentry-element="AppButtonPricing" data-sentry-source-file="buy-box-sale.tsx" />

            <SnappPayMessage className='lg:mt-2' mode='desktop' data-sentry-element="SnappPayMessage" data-sentry-source-file="buy-box-sale.tsx" />

            <div className='relative hidden w-full lg:mt-4 lg:flex'>
                <div className={classNames('!absolute w-full transition-all duration-300', showVariantError ? 'bottom-[calc(100%_+_4px)] opacity-100' : 'bottom-0 -z-10 opacity-0')}>
                    <Snackbar size='large' state='error' style='filled' type='text' className='z-10 mt-1 hidden h-fit w-full lg:flex' data-sentry-element="Snackbar" data-sentry-source-file="buy-box-sale.tsx">
                        {variantErrorMessage}
                    </Snackbar>
                </div>

                <PDPButton showVariantErrorHandler={showVariantErrorHandler} data-sentry-element="PDPButton" data-sentry-source-file="buy-box-sale.tsx" />
            </div>
        </div>;
};
export default BuyBoxSale;